import PostHashtagService from '../../../modules/postHashtag/postHashtagService'
import Errors from '../../../modules/shared/error/errors'
import Message from '../../../view/shared/message'
import { push } from 'redux-first-history'
import { i18n } from '../../../i18n'

const prefix = 'POSTHASHTAG_FORM'

const postHashtagFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: postHashtagFormActions.INIT_STARTED,
      })

      let record = {}

      const isEdit = Boolean(id)

      if (isEdit) {
        record = await PostHashtagService.find(id)
      }

      dispatch({
        type: postHashtagFormActions.INIT_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: postHashtagFormActions.INIT_ERROR,
      })

      dispatch(push('/post-hashtag'))
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: postHashtagFormActions.CREATE_STARTED,
      })

      await PostHashtagService.create(values)

      dispatch({
        type: postHashtagFormActions.CREATE_SUCCESS,
      })

      Message.success(
        i18n('entities.postHashtag.create.success'),
      )

      dispatch(push('/post-hashtag'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: postHashtagFormActions.CREATE_ERROR,
      })
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: postHashtagFormActions.UPDATE_STARTED,
      })

      await PostHashtagService.update(id, values)

      dispatch({
        type: postHashtagFormActions.UPDATE_SUCCESS,
      })

      Message.success(
        i18n('entities.postHashtag.update.success'),
      )

      dispatch(push('/post-hashtag'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: postHashtagFormActions.UPDATE_ERROR,
      })
    }
  },
}

export default postHashtagFormActions
